import React from "react";
import { motion } from "framer-motion";
import { Compass, ShieldCheck, Microscope, Clock, BadgeCheck, MapPinned } from "lucide-react";

const items = [
  {
    icon: Microscope,
    title: "Clinical Approach",
    desc: "Assessment-led methodology. No guesswork, no gym bro programs.",
  },
  {
    icon: ShieldCheck,
    title: "Joint-Safe Strength",
    desc: "Programs designed to build longevity, not break down your body.",
  },
  {
    icon: BadgeCheck,
    title: "Elite Credentials",
    desc: "10+ years coaching as a Master Trainer at Fitness First DIFC.",
  },
  {
    icon: Compass,
    title: "Personalised Plans",
    desc: "Every plan is unique. Built around your screen, your goals, your life.",
  },
  {
    icon: Clock,
    title: "Long-Term Results",
    desc: "Outcomes engineered to compound, not collapse, over months and years.",
  },
  {
    icon: MapPinned,
    title: "Premium Dubai Locations",
    desc: "Train inside Dubai Mall · Zabeel Expansion or online from anywhere.",
  },
];

export const WhyChoose = () => {
  return (
    <section
      id="why"
      data-testid="why-choose-section"
      className="relative py-20 sm:py-28 lg:py-36 border-t border-white/5 overflow-hidden"
    >
      <div className="aurora" style={{ background: "#0055FF", width: 500, height: 500, top: -100, right: -150, opacity: 0.2 }}></div>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative z-10">
        <div className="max-w-3xl mb-16">
          <div className="text-xs uppercase tracking-[0.3em] text-[#00E5FF] mb-4">Why Corrective Motion</div>
          <h2 className="font-display text-4xl lg:text-5xl xl:text-6xl font-extrabold leading-[1.05] tracking-[-0.02em] text-white">
            Not a gym. <span className="text-gradient-blue">A performance lab.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((it, i) => (
            <motion.div
              key={it.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              data-testid={`why-item-${i}`}
              className="rounded-2xl p-7 glass glass-hover relative group"
            >
              <div className="absolute top-6 right-6 text-[10px] font-mono text-zinc-600 tracking-widest">
                /{(i + 1).toString().padStart(2, "0")}
              </div>
              <div className="w-12 h-12 rounded-xl border border-white/10 bg-black/30 flex items-center justify-center">
                <it.icon className="w-5 h-5 text-[#00E5FF]" />
              </div>
              <div className="mt-5 font-display text-xl font-bold text-white">{it.title}</div>
              <p className="mt-2 text-sm text-zinc-400 leading-relaxed">{it.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
